export default "__VITE_ASSET__DVD5NCJA__"